import { Fab } from '@mui/material';
import { type ReactElement } from 'react';

type FloatingBottomButtonProps = {
  title?: string;
  icon?: ReactElement;
  onAction: () => void;
  bottom?: number;
  right?: number;
  hasBorder?: boolean;
  position?: 'fixed' | 'absolute';
  variant?: 'extended' | 'circular';
};

export default function FloatingBottomButton({
  title,
  icon,
  onAction,
  bottom = 80,
  right = 12,
  hasBorder = false,
  position = 'fixed',
  variant = 'extended',
}: FloatingBottomButtonProps) {
  return (
    <>
      <Fab
        variant={variant}
        color="secondary"
        onClick={onAction}
        sx={{
          position,
          bottom,
          right,
          zIndex: 1,
          ...(hasBorder && { border: '2px solid #ffffff' }),
          boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.3)',
          gap: 1,
          color: 'white',
        }}
      >
        {icon}
        {title}
      </Fab>
    </>
  );
}
